import { gql } from '@apollo/client';

export const MODEL_NAMES = gql`
  query getAvailableModelNames($inputModelName: String, $inputBrandNames: [String!], $inputVehicleYears: [Int!]) {
    getAvailableModelNames(
      inputModelName: $inputModelName
      inputBrandNames: $inputBrandNames
      inputVehicleYears: $inputVehicleYears
    )
  }
`;
